import { AuthEnums } from "models/enums";
import { FileHelper } from "utils/helpers";
import useAPIClientHelper from "./useAPIClientHelper";

function useAuditService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getAuditSheetPdf = (auditSheetId: number) => {
    apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
      responseType: "arraybuffer",
    })
      .AuditClient.GetAuditSheetPdfAsync(auditSheetId)
      .then((res) => {
        FileHelper.download(res);
      });
  };
  const getAuditSheet = (auditSheetId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true })
      .AuditClient.GetAuditSheetDetails(auditSheetId)
      .then((res) => res.data);
  };
  const getAttachment = (auditSheetId: number, attachmentId: string, wintAccountingVoucherId?: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true })
      .AuditClient.GetAttachment(auditSheetId, attachmentId, wintAccountingVoucherId)
      .then((res) => res.data);
  };

  return {
    getAuditSheetPdf,
    getAuditSheet,
    getAttachment,
  };
}

export default useAuditService;
